import Axios from 'utils/axios'

const module = {
	namespaced:true,
	state: {
		error: null,
		pending: false
	},
	mutations: {

	},
	actions: {
		upload_file({commit}, {file}) {
			let formData = new FormData()
			formData.append('file', file)
			return new Promise((resolve)=>{
				Axios.post('/admin/upload', formData, {
					headers:{
						'Content-type':'multipart/form-data'
					}
				}).then((res)=>{
					resolve(res.url[0])
				})
			})
		}
	}
}

export default module
